const spousalMaintenance = {
  pageTitle: "Eigener Unterhaltsanspruch",
  intro:
    "Die folgenden Fragen sollen helfen herauszufinden, ob Sie einen Unterhaltsanspruch gegenüber Ihrem:r Ehepartner:in haben.",
  questions: {
    isMarried: "Sind Sie verheiratet?",
    spouseIncome: "Wie hoch ist das monatliche Durchschnittseinkommen Ihres:r Ehepartner:in?",
    hasOwnIncome: "Haben Sie ein eigenes Einkommen?",
    ownIncome: "Wie hoch ist Ihr eigenes monatliches Durchschnittseinkommen?",
    livingTogether: "Leben Sie mit Ihrem:r Ehepartner:in zusammen?",
    housingCosts: "Wie hoch sind die gemeinsamen monatlichen Wohnungskosten?",
    children: "Für wie viele Kinder ist Ihr:e Ehepartner:in unterhaltspflichtig?",
  },
  info: {
    livingTogether:
      "In der Folge wird davon ausgegangen, dass Ihr:e Ehepartner:in für die laufenden Wohnungskosten aufkommt.",
    livingApart: "In der Folge wird davon ausgegangen, dass Sie selbst für Ihre Wohnungskosten aufkommen müssen.",
  },
  notMarried: "Sie sind nicht verheiratet, weshalb Sie auch keinen Gattenunterhaltsanspruch haben können.",
  ownIncomeExceedsForty:
    "Ihr eigenes Einkommen übersteigt 40% des gemeinsamen Haushaltseinkommens, weshalb Sie auch keinen darüber hinausgehenden Gattenunterhaltsanspruch haben.",
  claimHeadline: "Der Unterhaltsanspruch gegenüber Ihrem:r Ehepartner:in beträgt: {{claim}} monatlich.",
  summaryIntro: "Zusammenfassend kann über Ihr Einkommen gesagt werden:",
  // Screen-reader-only announcement so newly revealed (or hidden) questions are noticed.
  questionsShown_one: "{{count}} Frage angezeigt",
  questionsShown_other: "{{count}} Fragen angezeigt",
  summary: {
    // "(= 33% − 8% (= 2 Kinder × 4%))" — childText is the pluralized childCount below.
    parenthetical: "(= {{basePercent}}% − {{reduction}}% (= {{childText}} × 4%))",
    childCount_one: "{{count}} Kind",
    childCount_other: "{{count}} Kinder",
    noOwnIncome: {
      intro: "Ich habe kein Einkommen, mein:e Ehepartner:in kommt für meinen Unterhalt auf.",
      incomeTogether:
        "Das Haushaltseinkommen (= Einkommen meines:r Ehepartner:in) beträgt durchschnittlich {{spouseIncome}}. Abzüglich der Wohnungskosten in der Höhe von {{housingDeducted}} verbleibt ein monatliches frei verfügbares Haushaltseinkommen von {{spouseFreeIncome}}.",
      incomeApart: "Das Einkommen meines:r Ehepartner:in beträgt durchschnittlich {{spouseIncome}}.",
      legal:
        "Aufgrund § 94 Abs. 3 ABGB sowie der gängigen Rechtsprechung, dass der:die Ehepartner:in, der:die kein Einkommen hat, einen Unterhaltsanspruch in der Höhe von 33% abzüglich je 4% für weitere Unterhaltspflichten gegenüber dem:der anderen Ehepartner:in hat (= 33%-Regel), habe ich einen gesetzlichen Unterhaltsanspruch in der Höhe von {{effectivePercent}}% {{parenthetical}}, was einem monatlichen Betrag von {{claim}} (= {{effectivePercent}}% von {{spouseFreeIncome}}) entspricht, gegenüber meinem:r Ehepartner:in.",
    },
    ownIncome: {
      intro:
        "Ich habe ein Einkommen in der Höhe von {{ownIncome}}. Mein:e Ehepartner:in hat ein Einkommen von {{spouseIncome}}.",
      incomeTogether:
        "Das Haushaltseinkommen beträgt somit {{jointIncome}}. Abzüglich der Wohnungskosten in der Höhe von {{housingDeducted}} verbleibt ein monatliches frei verfügbares Haushaltseinkommen von {{jointFreeIncome}}.",
      incomeApart: "Das gemeinsame Einkommen beträgt somit {{jointIncome}}.",
      legal:
        "Aufgrund § 94 Abs. 3 ABGB sowie der gängigen Rechtsprechung, dass der:die Ehepartner:in, der:die ein eigenes Einkommen hat, einen Unterhaltsanspruch in der Höhe von 40% abzüglich je 4% für weitere Unterhaltspflichten gegenüber dem:der anderen Ehepartner:in hat (= 40%-Regel), habe ich einen gesetzlichen Unterhaltsanspruch in der Höhe von {{effectivePercent}}% {{parenthetical}}, was einem monatlichen Betrag von {{fortyRuleAmount}} abzüglich des eigenen Einkommens von {{ownIncome}} entspricht, gegenüber meinem:r Ehepartner:in.",
      cap: " Aufgrund des Umstandes, dass der Unterhaltsanspruch nach der 33%-Regel jedoch geringer ist als nach der 40%-Regel, reduziert sich der Unterhaltsanspruch auf {{thirdRuleAmount}}.",
    },
  },
};

export default spousalMaintenance;
